import { render, staticRenderFns } from "./otpalternatives.vue?vue&type=template&id=40ade1ff"
import script from "./otpalternatives.vue?vue&type=script&lang=js"
export * from "./otpalternatives.vue?vue&type=script&lang=js"
import style0 from "./otpalternatives.vue?vue&type=style&index=0&id=40ade1ff&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./otpalternatives.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports